<script>
import {shallowReactive} from 'vue';
import axios from 'axios';
import {
    VueFlux,
    Img,
    FluxControls,
    FluxCaption,
    FluxPreloader,
    FluxPagination,
    FluxIndex,
    Book,
    Zip,
    Fade,
    Cube,
    Wave
} from 'vue-flux';
import 'vue-flux/style.css';

export default {
    name: 'Slider',
    inject: ['localeUrl', 'myTranslate', 'lang'],
    props: ['data'],
    components: {VueFlux, FluxIndex, FluxPagination, FluxPreloader, FluxCaption, FluxControls},
    // Properties returned from data() become reactive state
    // and will be exposed on `this`.
    data() {
        return {
            loadedImages: [],
            dataImages: [],
            vfOptions: {}, // Define your options here
            // vfTransitions: [] ,
            vfTransitions: [Book, Zip, Fade, Wave],

        }
    },

    // Methods are functions that mutate state and trigger updates.
    // They can be bound as event handlers in templates.
    methods: {
        attrFil(attr) {
            return attr[this.lang] || attr['en'] || attr
        },
    },

    // Lifecycle hooks are called at different stages
    // of a component's lifecycle.
    // This function will be called when the component is mounted.
    async mounted() {
        this.vfTransitions = shallowReactive([Book, Zip, Fade, Wave]);
        this.vfOptions = shallowReactive({
            autoplay: true,
        });

        try {

            // const response =  await axios.get('/slider');
            //const images = response.data; // Adjust according to your API response structure
            const images = this.data; // Adjust according to your API response structure
            this.loadedImages = images; // Adjust according to your API response structure
            this.dataImages = images.map(image => new Img(image.image, this.attrFil(image.text)));


        } catch (error) {
            console.error('Failed to fetch images:', error);
            // Handle error (e.g., set an error state, show a message to the user, etc.)
        }

    }
}
</script>


<template>
    <div dir="ltr" class="bd-slider__section  pb-20 theme-bg">
        <div style="height: 700px;width: 100%" class="slider-container">


            <VueFlux
                style="height: 100%;width: 100%"
                v-if="loadedImages.length"
                :options="vfOptions"
                :rscs="dataImages"
                :transitions="vfTransitions"
                ref="$vueFlux">

                <template #preloader="preloaderProps">
                    <FluxPreloader v-bind="preloaderProps"/>
                </template>

                <!--            <template #caption="captionProps">
                                <FluxCaption v-bind="captionProps"/>
                            </template>-->

                <template #controls="controlsProps">
                    <FluxControls v-bind="controlsProps"/>
                </template>

            </VueFlux>
        </div>


    </div>


</template>
<style scoped>
.slider-container {
    height: 700px;
    width: 100%;
}
@media (max-width: 768px) {
    .slider-container {
        height: 300px;
    }
}
</style>
